export default __webpack_public_path__ + "static/media/basekit.3fe3ec97.svg";